import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Seo from '@/components/seo/Seo';

export default function ApplyCompletePage() {
  const { t } = useTranslation();
  return (
    <>
      <Seo route="/apply/complete" />
      <Header />
      <main className="pt-[120px] pb-20">
        <div className="max-w-[600px] mx-auto px-8 text-center">
          {/* Check Icon */}
          <div className="mb-8">
            <span className="inline-flex items-center justify-center w-20 h-20 rounded-full border border-accent-500/30 bg-accent-500/[0.04]">
              <i className="ri-check-line text-accent-400 text-3xl"></i>
            </span>
          </div>

          <h1 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('apply.complete.title')}
          </h1>
          <div className="gold-line mx-auto mb-6"></div>

          <p className="text-[17px] text-foreground-700 leading-relaxed tracking-[0.04em] mb-4">
            {t('apply.complete.p1')}
          </p>

          <p className="text-[16px] text-foreground-600 leading-relaxed tracking-[0.04em] mb-10">
            {t('apply.complete.p2')}
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/courses"
              className="px-8 py-3 border border-background-300 text-foreground-600 hover:text-foreground-800 hover:border-foreground-400 text-[15px] tracking-[0.08em] transition-all duration-300 whitespace-nowrap"
            >
              {t('apply.complete.coursesBtn')}
            </Link>
            <Link
              to="/"
              className="btn-glow px-8 py-3 bg-accent-500/90 hover:bg-accent-500 text-primary-900 text-[15px] tracking-[0.1em] font-medium transition-all duration-300 whitespace-nowrap"
            >
              {t('apply.complete.homeBtn')}
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
